import { AfterViewInit, Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-unit-payments]',
  template: `
    <div class="d-flex">
      <div>
        <button class="btn btn-outline-secondary btn-sm" (click)="generateEdoCuenta()">Edo. cuenta</button>
      </div>
      <div class="ms-auto">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button #1mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(1)">1 mes</button>
          <button #3mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(3)">3 meses</button>
          <button #6mes type="button" class="btn btn-sm btn-outline-secondary" (click)="updateFilter(6)">6 meses</button>
          <button #12mes type="button" class="btn btn-sm btn-outline-secondary active" (click)="updateFilter(12)">1 año</button>
          <button #custo type="button" class="btn btn-sm btn-outline-secondary">Filtrar</button>
        </div>
      </div>
    </div>
    <div class="d-flex mt-2 d-none">
      <div style="width: 70%;">
        <app-filter-advanced
          [toDate]="toDate"
          [fromDate]="fromDate"
          (dateRange)="updateDate($event)"
        ></app-filter-advanced>
      </div>
      <div class="ms-auto">
        <button class="btn btn-primary btn-sm rounded-3" (click)="searchBills()">
          <fa-icon [icon]="icons.faSearch" class="me-2"></fa-icon>
          Buscar
        </button>
      </div>
    </div>

    <div class="mt-3">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav-tabs">
        <li [ngbNavItem]="1" [destroyOnHide]="true" style="">
          <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Pagos</button>
          <ng-template ngbNavContent>
            <div id="historial" class="tab-pane historial  ps-1 pe-1">
              <table class="table table-sm table-striped mt-3" style="font-size: 0.8em;">
                <thead>
                  <tr>
                    <th class="text-start">#</th>
                    <th class="text-center">Lts.</th>
                    <th class="text-center"><fa-icon [icon]="icons.faCalendarAlt" class="me-1"></fa-icon> Vence</th>
                    <th class="text-center"><fa-icon [icon]="icons.faCalendarAlt" class="me-1"></fa-icon> Pago</th>
                    <th class="text-center">Subtotal</th>
                    <th class="text-center">Total</th>
                    <th class="text-center"><fa-icon [icon]="icons.faReceipt"></fa-icon></th>
                    <th class="text-center"><fa-icon [icon]="icons.faFilePdf"></fa-icon></th>
                  </tr>
                </thead>
                <tfoot *ngIf="summary.paid?.list.length>0" class="bg-secondary">
                  <tr>
                    <td colspan="5" class="mt-3 border-0"></td>
                  </tr>
                  <tr class="bg-secondary">
                    <td colspan="4" class="border-0"></td>
                    <td colspan="2" class="text-end text-secondary">Sub total</td>
                    <td colspan="2" class="text-end text-secondary">{{summary?.paid.sub_total | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border-0"></td>
                    <td colspan="2" class="text-end text-secondary">I.V.A.</td>
                    <td colspan="2" class="text-end text-secondary">{{summary?.paid.taxes | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border-0"></td>
                    <td colspan="2" class="text-end">Total</td>
                    <td colspan="2" class="text-end">{{summary?.paid.total | currency}}</td>
                  </tr>
                </tfoot>
                <tbody *ngIf="summary.paid?.list.length>0">
                  <tr *ngFor="let bill of summary?.paid?.list">
                    <td class="">{{bill?.id}}</td>
                    <td class="text-center">{{ bill?.consumo_lt | number: '1.2-2'}}</td>
                    <td class="text-center">{{ bill?.due_date | date: 'dd/MM/yy'}}</td>
                    <td class="text-center">{{ bill?.paid_date | date: 'dd/MM/yy'}}</td>
                    <td class="text-center">{{ bill?.sub_total | currency}}</td>
                    <td class="text-center">{{ bill?.total | currency}}</td>
                    <td class="text-center">
                      <button ngbDropdownItem (click)="downloadPaymentReceipt(bill)" class="btn btn-link text-primary">
                        <fa-icon [icon]="icons.faDownload" style="font-size: 0.75em;"></fa-icon>
                      </button>
                    </td>
                    <td class="text-center">
                      <button *ngIf="bill.invoiced" ngbDropdownItem (click)="downloadPaymentReceipt(bill)" class="btn btn-link text-primary">
                        <fa-icon [icon]="icons.faDownload" style="font-size: 0.75em;"></fa-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="summary.paid?.list.length==0">
                  <tr>
                    <td colspan="8" class="text-center p-5">No hay registros</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="true" style="">
          <button ngbNavLink class="btn btn-link bg-transparent rounded-0">No emitidos</button>
          <ng-template ngbNavContent>
            <div id="unpaid" class="tab-pane unpaid">
              <table class="table table-sm table-striped mt-3">
                <thead>
                  <tr>
                    <th># Recibo</th>
                    <th>Tipo</th>
                    <th class="text-center">Consumo</th>
                    <th class="text-center">Estatus</th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tfoot *ngIf="summary?.unpaid?.list?.length>0" class="bg-secondary">
                  <tr>
                    <td colspan="5" class="mt-3 border-0"></td>
                  </tr>
                  <tr class="bg-secondary">
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end text-secondary">Sub total</td>
                    <td class="text-end text-secondary">{{summary?.unpaid.sub_total | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end text-secondary">I.V.A.</td>
                    <td class="text-end text-secondary">{{summary?.unpaid.taxes | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end">Total</td>
                    <td class="text-end">{{summary?.unpaid.total | currency}}</td>
                  </tr>
                </tfoot>
                <tbody *ngIf="summary.unpaid?.list.length>0">
                  <tr *ngFor="let bill of summary?.unpaid?.list">
                    <td class=""><a href="/pagos/recibos/{{bill?.id}}">{{bill?.id}}-{{bill?.reference}}</a></td>
                    <td class=""><span *ngIf="bill?.adv">Anticipo</span><span *ngIf="!bill?.adv">Normal</span></td>
                    <td class="text-center">{{bill?.consumo_lt | number: '1.2-2'}}</td>
                    <td class="text-center ">{{ overduebill(bill) }}</td>
                    <td class="text-end ">{{bill?.total | currency}}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="summary?.unpaid?.list?.length==0">
                  <tr>
                    <td colspan="5" class="text-center p-5">No hay registros</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="true" style="">
          <button ngbNavLink class="btn btn-link bg-transparent rounded-0">No pagados</button>
          <ng-template ngbNavContent>
            <div id="adeudos" class="tab-pane adeudos">
              <table class="table table-sm table-striped mt-3">
                <thead>
                  <tr>
                    <th># Recibo</th>
                    <th>Tipo</th>
                    <th class="text-center">Consumo</th>
                    <th class="text-center">Estatus</th>
                    <th class="text-end">Total</th>
                    <th class="text-end"></th>
                  </tr>
                </thead>
                <tfoot *ngIf="summary.pending?.list.length>0" class="bg-secondary">
                  <tr>
                    <td colspan="5" class="mt-3 border-0"></td>
                  </tr>
                  <tr class="bg-secondary">
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end text-secondary">Sub total</td>
                    <td class="text-end text-secondary">{{summary.pending.sub_total | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end text-secondary">I.V.A.</td>
                    <td class="text-end text-secondary">{{summary.pending.taxes | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="border-0"></td>
                    <td class="text-end">Total</td>
                    <td class="text-end">{{summary.pending.total | currency}}</td>
                  </tr>
                </tfoot>
                <tbody *ngIf="summary.pending?.list.length>0">
                  <tr *ngFor="let bill of summary.pending.list">
                    <td class=""><a href="/pagos/recibos/{{bill.id}}">#{{bill.id}} {{bill.reference}}</a></td>
                    <td class=""><span *ngIf="bill.adv">Anticipo</span><span *ngIf="!bill.adv">Normal</span></td>
                    <td class="text-center">{{bill.consumo_lt | number: '1.2-2'}}</td>
                    <td class="text-center">{{ overduebill(bill) }}</td>
                    <td class="text-end">{{bill.total | currency}}</td>
                    <td class="text-end">
                      <button class="btn btn-link p-0" (click)="downloadReceipt(bill)">
                        <fa-icon [icon]="icons.faDownload" class="text-primary"></fa-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="summary.pending?.list.length==0">
                  <tr>
                    <td colspan="6" class="text-center p-5">No hay registros</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="true" style="">
          <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Facturas</button>
          <ng-template ngbNavContent>
            <div id="facturas" class="tab-pane facturas" >
              <table class="table table-sm table-striped mt-3">
                <thead>
                  <tr>
                    <th># Factura</th>
                    <th>Tipo</th>
                    <th class="text-center">Estatus</th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tfoot *ngIf="summary.invoiced?.list.length>0" class="bg-secondary">
                  <tr>
                    <td colspan="4" class="mt-3 border-0"></td>
                  </tr>
                  <tr class="bg-secondary">
                    <td colspan="2" class="border-0"></td>
                    <td class="text-secondary text-end">Sub total</td>
                    <td class="text-end text-secondary">{{summary.invoiced.sub_total | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="border-0"></td>
                    <td class="text-secondary text-end">I.V.A.</td>
                    <td class="text-end text-secondary">{{summary.invoiced.taxes | currency}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="border-0"></td>
                    <td class="text-end">Total</td>
                    <td class="text-end">{{summary.invoiced.total | currency}}</td>
                  </tr>
                </tfoot>
                <tbody *ngIf="summary.invoiced?.list.length>0">
                  <tr *ngFor="let bill of summary.invoiced.list">
                    <td class=""><a href="/pagos/recibos/{{bill.id}}">{{bill.reference}}</a></td>
                    <td class=""><span *ngIf="bill.adv">Anticipo</span><span *ngIf="!bill.adv">Normal</span></td>
                    <td class="text-center ">{{ overduebill(bill) }}</td>
                    <td class="text-end ">{{bill.total | currency}}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="summary.invoiced?.list.length==0">
                  <tr>
                    <td colspan="4" class="text-center p-5">No hay registros</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
  `,
  styleUrls: []
})
export class UnitPaymentsComponent implements AfterViewInit {
  @Input() profile: any;
  @Input() permissions: any;
  @Input() unit: any;
  @Input() summary: any;

  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;

  active = 1;

  apiUrl: string = environment.AWS_REST_WSPREFIX;
  receiptUrl: string = environment.RECIBOS_REST_WSPREFIX;

  a = new Date();
  fromDate: any; // = "2023/12/01"; // Date = new Date();
  toDate: any; // = "2024/02/02"; // Date = new Date();

  query: any = {
    unit_id: 0,
    date_from: '',
    date_to: '',
  };

  constructor(
    private store: SettlementsService,
    public images: ImageService,
    public icons: IconsService
  ) {
    const today = new Date();
    today.setMonth(today.getMonth() - 12);
    const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.query.date_from = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
    this.query.unit_id = this.unit?.id;
    this.query.date_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
  }

  updateFilter(mes: number) {
    const today = new Date();
    today.setMonth(today.getMonth() - mes);
    const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.query.date_from = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
    this.query.date_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;

    this.loadBills(this.query);

    if (mes == 1) {
      this.oneMonth.nativeElement.classList.add('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
    }
    if (mes == 3) {
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.add('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
    }
    if (mes == 6) {
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.add('active');
      this.twelveMonth.nativeElement.classList.remove('active');
    }
    if (mes == 12) {
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.add('active');
    }

  }

  ngAfterViewInit(): void {
    if (!this.unit.id) return;
    this.loadBills(this.query);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['unit'] && changes['unit'].currentValue) {
      this.query.unit_id = changes['unit'].currentValue.id;
      this.loadBills(this.query);
    }
  }

  overduebill(bill: any) {
    return new Date(bill.due_date) < new Date() ? "Vencido" : 'Vigente';
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
    //
    this.query.date_from = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
    this.query.date_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
  }

  searchBills() {
    this.loadBills(this.query);
  }

  loadBills(query: any) {
    if (!query.unit_id) return;
    this.store.getBillByUnitSummary(
      query.unit_id, 
      { 
        created_at_since: query.date_from,
        created_at_to: query.date_to
      }).subscribe({
        next: (data: any) => {
          this.summary = data;
        }, error: (err: any) => {
          console.error(err);
        }
    });
  }

  downloadReceipt(bill: any) {
    window.open(`${this.receiptUrl}/public/${bill.pdf}`, '_blank');
  }

  async downloadPaymentReceipt(bill: any) {
    await this.store.getTransactionByBill(bill.id).subscribe(async (transaction: any) => {
      const img = this.images.buildURL(this.profile.logo);
      const imx: any = await this.images.getBase64ImageFromUrl(img);
      this.profile.logo = `${imx.split(',')[1]}`;

      let payload = {
        bill: bill,
        transaction: transaction,
        profile: this.profile
      }
      this.store.downloadPaymentReceipt(payload).subscribe((data: any) => {
        const int8Array = new Uint8Array(data.result.data);
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          var fileURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');

          link.href = fileURL;
          link.download = data.filename;
          link.click();
      });
    });
  }

  generateEdoCuenta() {
    // this.store.getUnitStatment().subscribe((data: any) => {});
    this.store.getUnitStatement(this.unit.id).subscribe((data: any) => {
      this.store.reportUnitStatement(data).subscribe((data: any) => {
        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();
      });
    });
  }

}
